import { combineReducers } from 'redux';
import DynamicElements from './index';

const DynamicElementsReducer = combineReducers({
  DynamicElements,
});

export default DynamicElementsReducer;
